import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent { }



// WEBPACK FOOTER //
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/navbar/navbar.component.ts